// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for RosterStore, for use in the registry */ export const RosterStoreActionTypes = [
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.AddUsersToRosterMembersAction,
    ActionType.AddUserToRosterMembersSucceededAction,
    ActionType.AddUserToRosterMembersFailedAction,
    ActionType.RemoveUserFromRosterMembersAction,
    ActionType.RemoveUserFromRosterMembersSucceededAction,
    ActionType.RemoveUserFromRosterMembersFailedAction
];
